import { NewOrderScenario, TNewOrderForm } from "../types";

export const newOrderDefaultState: TNewOrderForm = {
  type: null,
  app: null,
  dateStart: null,
  dateStop: null,
  attributesList: [],
  delayedStart: {
    enable: false,
    value: null,
  },
  countriesList: [],
  activeScenario: NewOrderScenario.create,
};

// Функция для создания свежей копии дефолтного состояния
export const getNewOrderDefaultState = (): TNewOrderForm => ({
  type: null,
  app: null,
  dateStart: null,
  dateStop: null,
  attributesList: [],
  delayedStart: {
    enable: false,
    value: null,
  },
  countriesList: [],
  activeScenario: NewOrderScenario.create,
});
